import React from "react";

/* ══════════════════════════════════════════════════════════════
   FORMIGEN LOGO — Generative AI Engineering & Design Engine
   Design language: matches Luminex / Docuweave / Assayo family.
   Icon: distilled P&ID motif (vessel + PSV + LT balloon + AI glow + flow)
   Wordmark: italic serif "Formigen" with orange accent 'c'
   Devanagari:  — italic orange
   Both themes supported via CSS variables (strokes inherit theme text color)
   ══════════════════════════════════════════════════════════════ */

export function FormigenIcon({ size = 64 }) {
  return (
    <svg
      viewBox="0 0 56 72"
      width={size}
      height={Math.round(size * 72 / 56)}
      aria-hidden="true"
      className="rc-mark"
    >
      {/* Top PSV (orange safety valve) */}
      <line x1="28" y1="2" x2="28" y2="11" className="rc-mark-accent" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M 24,6 L 28,10 L 32,6" fill="none" className="rc-mark-accent" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />

      {/* Vessel body — straight sides + elliptical caps */}
      <ellipse cx="28" cy="14" rx="12" ry="4" className="rc-mark-stroke" fill="none" strokeWidth="1.8" />
      <line x1="16" y1="14" x2="16" y2="50" className="rc-mark-stroke" strokeWidth="1.8" />
      <line x1="40" y1="14" x2="40" y2="50" className="rc-mark-stroke" strokeWidth="1.8" />
      <ellipse cx="28" cy="50" rx="12" ry="4" className="rc-mark-stroke" fill="none" strokeWidth="1.8" />

      {/* Inlet flow arrow (left into vessel) */}
      <line x1="2" y1="24" x2="16" y2="24" className="rc-mark-flow" strokeWidth="1.6" strokeLinecap="round" />
      <polygon points="11,21 15,24 11,27" className="rc-mark-flow-fill" />

      {/* LT instrument balloon + dashed tap */}
      <line x1="40" y1="28" x2="46" y2="28" className="rc-mark-signal" strokeWidth="0.9" strokeDasharray="2,2" />
      <circle cx="50" cy="28" r="5" fill="var(--bg-elev, #fff)" className="rc-mark-stroke" strokeWidth="1.2" />
      <line x1="45" y1="28" x2="55" y2="28" className="rc-mark-stroke" strokeWidth="0.7" opacity="0.5" />

      {/* Control valve hint (bowtie) on outlet */}
      <polygon points="44,42 48,44 44,46" fill="none" className="rc-mark-stroke" strokeWidth="1.2" />
      <polygon points="52,42 48,44 52,46" fill="none" className="rc-mark-stroke" strokeWidth="1.2" />

      {/* Outlet flow arrow */}
      <line x1="40" y1="44" x2="44" y2="44" className="rc-mark-flow" strokeWidth="1.4" strokeLinecap="round" />
      <polygon points="52,44 56,44 52,46 56,44 52,42" fill="none" strokeWidth="0" />

      {/* Downcomer + pump at bottom */}
      <line x1="28" y1="54" x2="28" y2="62" className="rc-mark-flow" strokeWidth="1.6" strokeLinecap="round" />
      <polygon points="25,59 28,62 31,59" className="rc-mark-flow-fill" />
      <circle cx="28" cy="66" r="4" fill="none" className="rc-mark-stroke" strokeWidth="1.4" />

      {/* AI brain glow — the signature */}
      <circle cx="28" cy="32" r="6" fill="#F26B1F" opacity="0.08" />
      <circle cx="28" cy="32" r="3.5" fill="#F26B1F" opacity="0.22" />
      <circle cx="28" cy="32" r="1.8" fill="#F26B1F" />
    </svg>
  );
}

export default function FormigenLogo() {
  return (
    <span className="grantha-indo rc-logo-lockup" data-testid="rc-logo">
      <span className="rc-mark-wrap"><FormigenIcon /></span>
      <span className="rc-wordmark">
        Formi<span className="rc-c">g</span>en
      </span>
      <span className="grantha-dev rc-dev">{""}</span>
    </span>
  );
}
